<!--Filter Code  -->

<div class="col-lg-12 nopadding">
  <app-filter-panel [GridColumns]="GridColumns" [DefaultFilterArray]="DefaultFilterArray"
      (FilterEvent)="FilterApplyFilterEvent($event)">
  </app-filter-panel>
</div>

<!--Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(isLoadingResults){
  <div class="example-loading-shade">
    @if(isLoadingResults){
      <mat-spinner></mat-spinner>}
  </div>}
  <app-grid [PageName]="'System-Monitoring'" [GridColumns]="GridColumns" [Dataset]="dataset1" [TotalRecords]="totalRecords"
      (RestLimitEvent)="GridChangeLimitEvent($event)" (exportData)="exportToCSV($event)">
  </app-grid>
</div>